// Do not edit directly, this file was auto-generated.
// Regenerate: npm run generate:tokens
export var Spacing;
(function (Spacing) {
    Spacing["L"] = "gp-l";
    Spacing["M"] = "gp-m";
    Spacing["None"] = "gp-none";
    Spacing["S"] = "gp-s";
    Spacing["Xl"] = "gp-xl";
    Spacing["Xs"] = "gp-xs";
    Spacing["Xxl"] = "gp-xxl";
    Spacing["Xxxl"] = "gp-xxxl";
    Spacing["Xxxxl"] = "gp-xxxxl";
    Spacing["Xxxxxl"] = "gp-xxxxxl";
})(Spacing || (Spacing = {}));
export var PaddingHorizontal;
(function (PaddingHorizontal) {
    PaddingHorizontal["L"] = "pd-h-l";
    PaddingHorizontal["M"] = "pd-h-m";
    PaddingHorizontal["None"] = "pd-h-none";
    PaddingHorizontal["S"] = "pd-h-s";
    PaddingHorizontal["Xl"] = "pd-h-xl";
    PaddingHorizontal["Xs"] = "pd-h-xs";
    PaddingHorizontal["Xxl"] = "pd-h-xxl";
    PaddingHorizontal["Xxxl"] = "pd-h-xxxl";
    PaddingHorizontal["Xxxxl"] = "pd-h-xxxxl";
    PaddingHorizontal["Xxxxxl"] = "pd-h-xxxxxl";
})(PaddingHorizontal || (PaddingHorizontal = {}));
export var PaddingVertical;
(function (PaddingVertical) {
    PaddingVertical["L"] = "pd-v-l";
    PaddingVertical["M"] = "pd-v-m";
    PaddingVertical["None"] = "pd-v-none";
    PaddingVertical["S"] = "pd-v-s";
    PaddingVertical["Xl"] = "pd-v-xl";
    PaddingVertical["Xs"] = "pd-v-xs";
    PaddingVertical["Xxl"] = "pd-v-xxl";
    PaddingVertical["Xxxl"] = "pd-v-xxxl";
    PaddingVertical["Xxxxl"] = "pd-v-xxxxl";
    PaddingVertical["Xxxxxl"] = "pd-v-xxxxxl";
})(PaddingVertical || (PaddingVertical = {}));
export var PaddingAll;
(function (PaddingAll) {
    PaddingAll["L"] = "pd-a-l";
    PaddingAll["M"] = "pd-a-m";
    PaddingAll["None"] = "pd-a-none";
    PaddingAll["S"] = "pd-a-s";
    PaddingAll["Xl"] = "pd-a-xl";
    PaddingAll["Xs"] = "pd-a-xs";
    PaddingAll["Xxl"] = "pd-a-xxl";
    PaddingAll["Xxxl"] = "pd-a-xxxl";
    PaddingAll["Xxxxl"] = "pd-a-xxxxl";
    PaddingAll["Xxxxxl"] = "pd-a-xxxxxl";
})(PaddingAll || (PaddingAll = {}));
